import React, { useState, useEffect } from "react";

export type StorageHook<T> = [T, React.Dispatch<React.SetStateAction<T>>];

export function useLocalStorage<T>(key: string, defaultValue: T) {
    return useStorage(key, defaultValue, window.localStorage);
}

export function useSessionStorage<T>(key: string, defaultValue: T) {
    return useStorage(key, defaultValue, window.sessionStorage);
}

function useStorage<T>(
    key: string,
    defaultValue: T | undefined,
    storageObject: Storage
): StorageHook<T | undefined> {
    const [value, setValue] = useState<T | undefined>(() => {
        const jsonValue = storageObject.getItem(key);
        if (jsonValue != null) return JSON.parse(jsonValue);

        if (typeof defaultValue === "function") {
            return defaultValue();
        } else {
            return defaultValue;
        }
    });

    useEffect(() => {
        if (value === undefined) return storageObject.removeItem(key);
        storageObject.setItem(key, JSON.stringify(value));
    }, [key, value, storageObject]);

    return [value, setValue];
}
